import React from 'react';
import { DividerBlock as DividerBlockType } from './types';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface DividerBlockProps {
  block: DividerBlockType;
  onChange: (block: DividerBlockType) => void;
  isEditing?: boolean;
}

export const DividerBlockDisplay: React.FC<{ block: DividerBlockType }> = ({ block }) => {
  if (block.orientation === 'horizontal') {
    return (
      <hr
        style={{
          border: 'none',
          borderTop: `${block.thickness}px solid ${block.color}`,
          width: `${block.length}%`,
          margin: '4px 0',
        }}
      />
    );
  }

  return (
    <div
      style={{
        width: block.thickness,
        height: block.length,
        backgroundColor: block.color,
      }}
    />
  );
};

export const DividerBlockEditor: React.FC<DividerBlockProps> = ({ block, onChange }) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>Orientation</Label>
        <Select
          value={block.orientation}
          onValueChange={(value: 'horizontal' | 'vertical') => onChange({ ...block, orientation: value })}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="horizontal">Horizontal</SelectItem>
            <SelectItem value="vertical">Vertical</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Thickness (px)</Label>
          <Input
            type="number"
            value={block.thickness}
            onChange={(e) => {
              const val = e.target.value;
              if (val === '') onChange({ ...block, thickness: '' as any });
              else { const num = parseInt(val); if (!isNaN(num)) onChange({ ...block, thickness: num }); }
            }}
            onBlur={(e) => {
              const num = parseInt(e.target.value);
              if (isNaN(num) || num < 1) onChange({ ...block, thickness: 1 });
            }}
          />
        </div>
        <div className="space-y-2">
          <Label>{block.orientation === 'horizontal' ? 'Width (%)' : 'Height (px)'}</Label>
          <Input
            type="number"
            value={block.length}
            onChange={(e) => {
              const val = e.target.value;
              if (val === '') onChange({ ...block, length: '' as any });
              else { const num = parseInt(val); if (!isNaN(num)) onChange({ ...block, length: num }); }
            }}
            onBlur={(e) => {
              const num = parseInt(e.target.value);
              if (isNaN(num) || num < 1) onChange({ ...block, length: 100 });
            }}
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label>Color</Label>
        <div className="flex gap-2">
          <input
            type="color"
            value={block.color}
            onChange={(e) => onChange({ ...block, color: e.target.value })}
            className="h-9 w-12 rounded border cursor-pointer"
          />
          <Input
            value={block.color}
            onChange={(e) => onChange({ ...block, color: e.target.value })}
            className="flex-1"
          />
        </div>
      </div>
    </div>
  );
};
